export default __webpack_public_path__ + "static/media/_avatar-2.c9d9b0ca.jpg";